<template>
  <div class="home" ref="home">
    <img style="width: 65%; height: 75%;" v-if="dslModel.imagesObj.home" :src="dslModel.imagesObj.home" alt="">
  </div>
</template>

<script>
import Baseunified from '../utils/micro/baseunified';
import { isCustomerSaasPrivate } from '@/utils/globalConfig';
import { getSubAppHomeMenu } from '@/utils/utils';
import { isCmhub } from '@/features/cmhub/config';

export default {
  name: 'Home',
  data() {
    return {
      model: null,
      dslModel: {
        imagesObj: {
          home: '',
        },
      },
    };
  },
  created() {
    this.model = new Baseunified();
    this.dslModel = this.model.getDslModel();
  },
  mounted() {
    if (isCmhub()) return;
    if (this.dslModel.imagesObj.home) {
      this.$refs.home.style.backgroundColor = '#fff';
    }

    let self = this;
    this.$nextTick(() => {
      if (window.location.hostname.toString().includes('skydome') || window.location.hostname.toString().includes('saas') || window.location.hostname.toString().includes('ynjt')) {
        self.$store.commit("delTab", 0);
        self.$router.push({
          path: isCustomerSaasPrivate() ? '/customerSaas/customer/smartScreen' : '/customerSaas/customer/dashboard',
        });
        return;
      }
      if (window.location.hostname.toString().includes('sh-dev') || window.location.hostname.toString().includes('sh-sit') || (window.location.hostname.toString().includes('sh.kaigongla'))) {
        self.$store.commit("delTab", 0);
        self.$router.push({
          path: '/delivery/merchantSaasHome',
        });
        return;
      }
      // 子工程自带"首页"菜单时，移除基座首页页签并跳转，避免出现两个"首页"
      if (self.$route.path === '/') {
        const subHome = getSubAppHomeMenu();
        if (subHome && subHome.menuPath) {
          self.$store.commit('delTab', 0);
          self.$router.replace({ path: subHome.menuPath });
        }
      }
    });
  },
};
</script>

<style lang="less" scoped>
.home {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
